function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.8335 4.99998C2.8335 4.53974 3.20659 4.16665 3.66683 4.16665H10.3335C10.7937 4.16665 11.1668 4.53974 11.1668 4.99998V4.99998C11.1668 5.46022 10.7937 5.83331 10.3335 5.83331H3.66683C3.20659 5.83331 2.8335 5.46022 2.8335 4.99998V4.99998ZM0.333496 1.66665C0.333496 1.20641 0.706592 0.833313 1.16683 0.833313H12.8335C13.2937 0.833313 13.6668 1.20641 13.6668 1.66665V1.66665C13.6668 2.12688 13.2937 2.49998 12.8335 2.49998H1.16683C0.706591 2.49998 0.333496 2.12688 0.333496 1.66665V1.66665ZM5.3335 8.33331C5.3335 7.87308 5.70659 7.49998 6.16683 7.49998H7.8335C8.29373 7.49998 8.66683 7.87308 8.66683 8.33331V8.33331C8.66683 8.79355 8.29373 9.16665 7.83349 9.16665H6.16683C5.70659 9.16665 5.3335 8.79355 5.3335 8.33331V8.33331Z",
  fill: "#373D49"
});

function SvgMoreFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFilterIcon);
export default __webpack_public_path__ + "static/media/more_filter_icon.8aa4a69f.svg";
export { ForwardRef as ReactComponent };